import {
  BOOK_LIST_SUCCESS,
  EBOOK_ONLY_LIST,
  CATEGORY_BOOKS_LIST,
  UNICOL_BOOKS_LIST,
  GENRE_BOOK_LIST,
  GENRE_LIST,
  GENRE_SUCCESS
} from '@/store/types'
import axios from '@/store/axios'
const state = {
  ebookOnly: null,
  newBooks: null,
  popular: null,
  category: null,
  unicolBooks: null,
  genre: {},
  genreMap: null
}

const getters = {
  getEbookOnlyList: (state) => state.ebookOnly,
  getGenre: (state) => state.genre,
  getGenreMap: (state) => state.genreMap,
  getCategoryBooksList: (state) => state.category,
  getUnicolBooksList: (state) => state.unicolBooks
}

const actions = {
  [UNICOL_BOOKS_LIST]: ({ commit }, { unicolCode }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/book/list/unicol?unicolCode=${unicolCode}`)
        .then((resp) => {
          commit(BOOK_LIST_SUCCESS, { unicolBooks: resp.data.result.list })
          resolve(resp)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  [EBOOK_ONLY_LIST]: ({ commit }, { pageNo = 1, pageRow = 10 }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/book/list/ebookonly?pageNo=${pageNo}&pageRow=${pageRow}`)
        .then((resp) => {
          commit(BOOK_LIST_SUCCESS, { ebookOnly: resp.data.result.list })
          resolve(resp)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  [GENRE_BOOK_LIST]: ({ commit }, { type, pageNo = 1, pageRow = 15 }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/recommend/book/${type}?pageNo=${pageNo}&pageRow=${pageRow}`)
        .then((resp) => {
          commit(GENRE_SUCCESS, { genre: resp.data.result.list, type: type })
          resolve(resp)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  [GENRE_LIST]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/recommend/type`)
        .then((resp) => {
          commit('fetchGenreMap', { list: resp.data.result.types })
          resolve(resp)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  [CATEGORY_BOOKS_LIST]: (
    { commit },
    { categoryCode = '00310081', pageNo = 1, pageRow = 12 }
  ) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/book/list/category/${categoryCode}?pageNo=${pageNo}&pageRow=${pageRow}`
        )
        .then((resp) => {
          commit(BOOK_LIST_SUCCESS, { category: resp.data.result.list })
          resolve(resp)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}
const mutations = {
  [BOOK_LIST_SUCCESS]: (
    state,
    { ebookOnly, newBooks, popular, category, unicolBooks }
  ) => {
    if (ebookOnly) {
      state.ebookOnly = ebookOnly
    }
    if (newBooks) {
      state.newBooks = newBooks
    }
    if (popular) {
      state.popular = popular
    }
    if (category) {
      state.category = category
    }
    if (unicolBooks) {
      state.unicolBooks = unicolBooks
    }
  },
  [GENRE_SUCCESS]: (state, { genre, type }) => {
    state.genre = {
      ...state.genre,
      [type]: genre
    }
  },
  fetchGenreMap(state, { list }) {
    state.genreMap = list
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}
